import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import React from "react";
import CancelTwoToneIcon from '@mui/icons-material/CancelRounded';

function AxiosError({ open, onClose, status = null, message = null, disableEscapeKeyDown = true }) {
    return (
        <Modal open={open} onClose={onClose} disableEscapeKeyDown={disableEscapeKeyDown}>
            <Box className="box-modal box-modal-xs p-5">
                <div className="pb-3 justify-content-center text-center">
                    <div className="pb-3">
                         <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor" class="bi bi-x-circle icon-grave" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                        </svg>
                    </div>
                    <div className="">
                        <Typography variant="h6">{message}</Typography>
                    </div>
                    <div className="pb-2">
                        <Typography className="" variant="subtitle2">{status}</Typography>
                    </div>
                </div>
                <div className="justify-content-center d-flex">
                    <Button className="w-100" color="error" variant="outlined" onClick={onClose}>
                        <Typography className="fw-bold " variant="h6">Aceptar</Typography>
                    </Button>
                </div>
            </Box>
        </Modal>
    );
}

export default AxiosError;
